import React from "react";

interface Props {
  className?: string;
  fill?: string;
  viewBox?: string;
}

const GroupIcon: React.FC<Props> = ({className, fill, viewBox}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox={viewBox}
    className={className}
  >
    <path
      fill={fill || "#9E9E9E"}
      d="M4.18945 0C2.25945 0 0.689453 1.57 0.689453 3.5C0.689453 6.125 4.18945 10 4.18945 10C4.18945 10 7.68945 6.125 7.68945 3.5C7.68945 1.57 6.11945 0 4.18945 0ZM4.18945 1C4.73945 1 5.18945 1.45 5.18945 2C5.18945 2.555 4.73945 3 4.18945 3C3.63945 3 3.18945 2.555 3.18945 2C3.18945 1.45 3.63945 1 4.18945 1ZM4.18945 6C3.35445 6 2.61945 5.575 2.18945 4.925C2.19945 4.265 3.52445 3.9 4.18945 3.9C4.85445 3.9 6.17945 4.265 6.18945 4.925C5.75945 5.575 5.02445 6 4.18945 6Z"
    />
  </svg>
);

export default GroupIcon;
